import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated } from '../lib/auth';

// Default landing — redirect to invoices if signed in, login otherwise.
// Both targets are added by wave-2 tasks.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (isAuthenticated()) {
      throw redirect({ to: '/invoices' });
    }
    throw redirect({ to: '/login' });
  },
});
